import React from 'react'

const AddonItem = ({
  addon,
  isSelected,
  isDeactivated,
  isQuantityAdjustable,
  onCheck,
  onIncrement,
  onDecrement,
  onQuantityInputBlur,
  onQuantityInputChange,
  quantity = 1,
  showPrice = false,
  minQuantity = 1,
  maxQuantity = null,
  isCheckboxDisabled = false,
  displayMultiplier,
  childrenAddonItems,
  itemLevel = 0,
}) => {
  const newItemLevel = itemLevel + 1
  return (
    <div>
      <label
        style={{
          padding: '10px 16px',
          border: isDeactivated
            ? '1px solid #bbb'
            : isSelected
            ? '1px solid rgba(5, 110, 49, 0.40)'
            : '1px solid #e5e5e5',
          minHeight: '70px',
          borderRadius: '3px',
          backgroundColor: isDeactivated
            ? '#e5e7eb'
            : isSelected
            ? 'rgba(5, 110, 49, 0.04)'
            : 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: isDeactivated ? 'not-allowed' : 'pointer',
          opacity: isDeactivated ? 0.6 : 1,
        }}
      >
        <div className="flex gap-4">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onCheck}
            disabled={isDeactivated || isCheckboxDisabled}
          />
          <div>
            <b
              style={{
                fontWeight: 'bold',
                color:
                  isDeactivated || isCheckboxDisabled ? '#9ca3af' : '#1f2937',
                opacity: isDeactivated || isCheckboxDisabled ? 0.7 : 1,
              }}
            >
              {addon.name}
            </b>
            {showPrice && addon.formattedPrice && (
              <div
                style={{
                  color:
                    isDeactivated || isCheckboxDisabled ? '#9ca3af' : 'inherit',
                  opacity: isDeactivated || isCheckboxDisabled ? 0.7 : 1,
                }}
              >
                {addon.formattedPrice}
              </div>
            )}
          </div>
        </div>
        <div className="flex">
          {isSelected && isQuantityAdjustable && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '16px',
              }}
            >
              {displayMultiplier && (
                <div
                  type="text"
                  value={quantity * displayMultiplier}
                  style={{
                    textAlign: 'center',
                    border: '2px solid #bbbbbb',
                    paddingBlock: '1px',
                    paddingInline: '12px',
                    borderRadius: '6px',
                    marginInline: '8px',
                    backgroundColor: 'white',
                  }}
                >
                  {quantity * displayMultiplier} pgs
                </div>
              )}
              <button
                type="button"
                onClick={e => {
                  e.stopPropagation()
                  onDecrement()
                }}
                disabled={quantity <= minQuantity}
                style={{
                  padding: '1px 12px',
                  background: 'white',
                  border: '2px solid #bbbbbb',
                  borderRadius: '6px 0px 0px 6px',
                }}
              >
                <b
                  className="text-thryv-orange-500"
                  style={{
                    opacity: maxQuantity && quantity <= minQuantity ? 0.4 : 1,
                  }}
                >
                  -
                </b>
              </button>
              <input
                type="number"
                min={1}
                value={quantity}
                onBlur={e => onQuantityInputBlur(e.target.value)}
                onChange={e => onQuantityInputChange(e.target.value)}
                style={{
                  width: '40px',
                  textAlign: 'center',
                  borderBlock: '2px solid #bbbbbb',
                  paddingBlock: '1px',
                }}
                className="no-spinner"
              />
              <button
                type="button"
                onClick={e => {
                  e.stopPropagation()
                  onIncrement()
                }}
                disabled={maxQuantity && quantity >= maxQuantity}
                style={{
                  padding: '1px 12px',
                  background: 'white',
                  border: '2px solid #bbbbbb',
                  borderRadius: '0px 6px 6px 0px',
                }}
              >
                <b
                  className="text-thryv-orange-500"
                  style={{
                    opacity: maxQuantity && quantity >= maxQuantity ? 0.4 : 1,
                  }}
                >
                  +
                </b>
              </button>
            </div>
          )}
        </div>
      </label>
      <div
        style={{
          opacity: isSelected ? 1 : 0.4,
          pointerEvents: isSelected ? 'auto' : 'none',
          cursor: isSelected ? 'auto' : 'not-allowed',
        }}
      >
        {childrenAddonItems?.length > 0 &&
          childrenAddonItems.map((childItem, index) => {
            return (
              <div
                key={childItem.summaryInfo?.addOnCode || index}
                style={{marginLeft: `${newItemLevel * 28}px`, marginTop: '8px'}}
              >
                <AddonItem
                  addon={childItem}
                  isSelected={childItem.selectedItem}
                  isDeactivated={childItem.isIncompatible}
                  quantity={childItem.selectedItem?.quantity}
                  isQuantityAdjustable={childItem.quantityAdjustable}
                  minQuantity={childItem.minIncrementalQuantity}
                  maxQuantity={childItem.maxQuantity}
                  isCheckboxDisabled={childItem.isDefaultAdded}
                  childrenAddonItems={childItem.children}
                  displayMultiplier={childItem.displayMultiplier}
                  showPrice={true}
                  onCheck={childItem.orderControlFunctions.onCheck}
                  onIncrement={childItem.orderControlFunctions.onIncrement}
                  onDecrement={childItem.orderControlFunctions.onDecrement}
                  onQuantityInputBlur={
                    childItem.orderControlFunctions.onQuantityInputBlur
                  }
                  onQuantityInputChange={
                    childItem.orderControlFunctions.onQuantityInputChange
                  }
                  itemLevel={newItemLevel + 1}
                />
              </div>
            )
          })}
      </div>
    </div>
  )
}

AddonItem.defaultProps = {
  quantity: 1,
  showPrice: false,
  minQuantity: 1,
  maxQuantity: null,
}

export default AddonItem
